export default __webpack_public_path__ + "static/media/metodo_de_pago.76c847fb.svg";